// @flow

import React from "react";
import SVG from "react-inlinesvg";
import cx from "classnames";

import styles from "./SvgButton.scss";

type SvgButtonProps = {
  src: string,
  alt: string,
  isDisabled: boolean,
  className: string,
  onClick: () => void,
  buttonRef: {
    current: null | HTMLButtonElement
  },
  hasColorOnFocus: boolean,
  label: string
};

const SvgButton = ({
  src,
  alt,
  onClick,
  className,
  isDisabled,
  buttonRef,
  hasColorOnFocus,
  label,
  ...restProps
}: SvgButtonProps) => (
  <button
    tabIndex="0"
    type="button"
    className={cx(styles.button, className, {
      [styles.disabled]: isDisabled,
      [styles.withColorOnFocus]: hasColorOnFocus
    })}
    onClick={onClick}
    disabled={isDisabled}
    {...restProps}
    ref={buttonRef}
  >
    {label && <span className={styles.label}>{label}</span>}
    <SVG cacheGetRequests src={src} alt={alt} />
  </button>
);

SvgButton.defaultProps = {
  isDisabled: false,
  hasColorOnFocus: true
};

export default SvgButton;
